import mapboxgl from "mapbox-gl";
import {
  BuildingsLayer,
  PointsSource,
  PointsLayer,
  LinesSource,
  LinesLayer
} from "../components/Map/layers";
import PacketService from "./packet-service";
import mathjs from "mathjs";

let mapConfig = {
  default: {
    token:
      "pk.eyJ1IjoiZGlnaW1vbmRvIiwiYSI6ImNqbjRkMHN0YjBjcWEzd29jMXp0cWMyZ3EifQ.p45IVJzpSp6ao0A670R57w",
    options: {
      container: "map-1",
      style: "mapbox://styles/mapbox/light-v9",
      center: [9.993473589420319, 53.54562119334656],
      zoom: 12,
      zoomNear: screen.width <= 600 ? 17.5 : 19
    }
  },
  detail: {
    token:
      "pk.eyJ1IjoiZGlnaW1vbmRvIiwiYSI6ImNqbjRkMHN0YjBjcWEzd29jMXp0cWMyZ3EifQ.p45IVJzpSp6ao0A670R57w",
    options: {
      container: "map-2",
      style: "mapbox://styles/mapbox/light-v9",
      center: [9.993473589420319, 53.54562119334656],
      zoom: screen.width <= 600 ? 17.5 : 19
    }
  }
};

// Is there a way to fetch existing markers???
let markerStore = {};

export default {
  layersCreated(map) {
    if (this.mapExist(map)) {
      if (map.getSource("points") || map.getSource("lines")) {
        return true;
      }
    }
    return false;
  },

  setDefaultStyle(style) {
    Object.keys(mapConfig).forEach(mapName => {
      mapConfig[mapName].options.style = style;
    });
  },

  mapExist(map) {
    return map !== undefined && typeof map === "object" && map && Boolean(map);
  },

  isValidMapName(mapName) {
    if (Object.keys(mapConfig).indexOf(mapName) === -1) {
      return false;
    }
    return true;
  },

  focus(map, center, zoom, pitch) {
    map.easeTo({
      center,
      zoom,
      pitch,
      bearing: 0
    });
  },

  getAccessToken(mapName) {
    if (this.isValidMapName(mapName)) {
      return mapConfig[mapName].token;
    }
  },

  getOptions(mapName) {
    if (this.isValidMapName(mapName)) {
      let data = mapConfig[mapName].options;
      data.style =
        localStorage.getItem("sbhMapsTheme") == null
          ? "mapbox://styles/mapbox/streets-v9"
          : localStorage.getItem("sbhMapsTheme");
      return data;
    }
  },

  addDefaultLayers(map) {
    if (!this.mapExist(map) || this.layersCreated(map)) {
      return;
    }
    map.addLayer(BuildingsLayer);
    map.addSource("points", PointsSource);
    map.addLayer(PointsLayer);
    map.addSource("lines", LinesSource);
    map.addLayer(LinesLayer);
  },

  drawPositionHistory(map, coordinates) {
    if (!this.layersCreated(map)) {
      return;
    }

    let features = PacketService.getFeaturesByCoordinates(coordinates);

    let lineCoordinates = [];
    features.forEach(feature => {
      lineCoordinates.push(feature.geometry.coordinates);
    });

    map.getSource("points").setData({
      type: "FeatureCollection",
      features: features
    });

    map.getSource("lines").setData({
      type: "Feature",
      properties: {},
      geometry: {
        type: "LineString",
        coordinates: lineCoordinates
      }
    });
  },

  removePositionHistory(map) {
    if (!this.layersCreated(map)) {
      return;
    }

    map.getSource("points").setData({
      type: "FeatureCollection",
      features: []
    });

    map.getSource("lines").setData({
      type: "Feature",
      properties: {},
      geometry: {
        type: "LineString",
        coordinates: []
      }
    });
  },

  createMarker(map, device) {
    let markerWrapper = this.createMarkerElement("div", "marker");

    let iconClass = "far fa-cloud";
    let iconStyle;
    let mathResult;

    let parsed =
      device.packets &&
      device.packets[0] &&
      device.packets[0].source_data &&
      device.packets[0].source_data &&
      device.packets[0].source_data.parsed
        ? device.packets[0].source_data.parsed
        : null;

    if (device.deviceType && device.deviceType.niota_maps) {
      if (device.hasAlert) {
        device.deviceType.niota_maps.icon_style = "#f46a6b";
      }
      iconClass = device.deviceType.niota_maps.icon_class || iconClass;
      iconStyle = "color:" + device.deviceType.niota_maps.icon_style;
    }

    let styleCalculators =
      device.deviceType &&
      device.deviceType.niota_maps &&
      device.deviceType.niota_maps.calculateStyleElements
        ? device.deviceType.niota_maps.calculateStyleElements
        : null;
    if (parsed && styleCalculators) {
      styleCalculators.some(styleCalc => {
        try {
          mathResult = mathjs.eval(`(${styleCalc.formula})`, parsed);
        } catch (e) {
          return e;
        }
        if (mathResult) {
          iconStyle = styleCalc.target;
          return true;
        }
      });
    }

    this.createMarkerElement(
      "i",
      "marker-background fas fa-map-marker",
      markerWrapper,
      iconStyle
    );
    this.createMarkerElement(
      "i",
      `marker-icon fa-fw ${iconClass}`,
      markerWrapper
    );

    markerWrapper.setAttribute("did", device.id);

    let marker = new mapboxgl.Marker(markerWrapper)
      .setLngLat([device.lon, device.lat])
      .addTo(map);

    device.markerEl = markerWrapper;
    device.marker = marker;
    markerStore[device.id] = {
      markerEl: device.markerEl,
      marker: marker
    };
  },

  getMarkerById(deviceId) {
    return markerStore[deviceId];
  },

  createMarkerElement(tag, className, parent = null, style) {
    let el = document.createElement(tag);
    el.className = className;
    if (style) {
      el.style = style;
    }
    if (parent) {
      parent.appendChild(el);
    }
    return el;
  }
};
